/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import pick from 'lodash/fp/pick.js';
import {
  GROUND_MOTION_METHOD,
  RETURN_PERIOD_DE,
  RETURN_PERIOD_MCE,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import {
  currentModelId,
  selectRunOutputDataForReturnPeriod,
  selectModelType,
} from '#selectors/entities/models.js';
import { modelTypesById } from '#src/js/constants/models/modelTypes/index.js';
import groundMotionIsUploadMethod from '#support/models/groundMotion/groundMotionIsUploadMethod.js';
import IntensityName from './IntensityName.jsx';

const mapStateToProps = (state, ownProps) => {
  const modelId = currentModelId(state);
  const modelTypeId = selectModelType(state, { modelId });
  const { selectFormValues } = modelTypesById[modelTypeId];
  const { returnPeriod, includeUploads } = ownProps;
  const {
    [RETURN_PERIOD_DE]: returnPeriodDE,
    [RETURN_PERIOD_MCE]: returnPeriodMCE,
    [GROUND_MOTION_METHOD]: groundMotionMethod,
  } = selectFormValues(state, RETURN_PERIOD_DE, RETURN_PERIOD_MCE, GROUND_MOTION_METHOD);
  const isGroundMotionUpload = groundMotionIsUploadMethod(groundMotionMethod);

  if (includeUploads && isGroundMotionUpload) {
    return {
      isDBE: parseInt(returnPeriodDE, 10) === returnPeriod,
      isMCE: parseInt(returnPeriodMCE, 10) === returnPeriod,
    };
  }
  return pick(
    ['isDBE', 'isMCE'],
    selectRunOutputDataForReturnPeriod(state, { returnPeriod, modelId })
  );
};

export default connect(mapStateToProps)(IntensityName);
